import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const location = useLocation();
  const { user, logout, can } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  const allNavItems = [
    { path: '/dashboard',        label: 'Dashboard',          icon: '📊', show: can('viewDashboard') },
    { path: '/projects',         label: 'Projects',           icon: '📁', show: can('viewProjects') },
    { path: '/plans',            label: 'Project Plans',      icon: '🗂️', show: can('createEditProject') },
    { path: '/employees',        label: 'Employees',          icon: '👥', show: can('manageEmployees') },
    { path: '/resources',        label: 'Resource View',      icon: '🗓️', show: can('viewResources') },
    { path: '/weekly',           label: 'Weekly Team View',   icon: '📋', show: can('viewResources') },
    { path: '/allocation',       label: 'Dynamic Allocation', icon: '⚡', show: can('viewAllocation') },
    { path: '/tasks/report',     label: 'Task Report',        icon: '📅', show: can('viewTaskReport') },
    { path: '/change-requests',  label: 'Change Requests',    icon: '🔄', show: can('manageChanges') },
    { path: '/raid',             label: 'RAID Log',           icon: '🛡️', show: can('manageRAID') },
    { path: '/users',            label: 'User Management',    icon: '👤', show: can('manageUsers') },
  ];

  const navItems = allNavItems.filter(i => i.show);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div className="layout">
      <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? '✕' : '☰'}
      </button>

      {mobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 }}
        />
      )}

      {/* Sidebar — flex column so nav scrolls and user panel sits naturally at bottom */}
      <aside className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}
      >
        {/* Logo */}
        <div style={{ background: '#fff', padding: '12px 20px', flexShrink: 0 }}>
          <img
            src="/Ilakku_Logo.png"
            alt="ilakku"
            style={{ width: '100%', display: 'block' }}
          />
        </div>

        {/* Nav — scrollable middle section */}
        <nav className="sidebar-nav" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
          {navItems.map((item) => (
            <Link key={item.path} to={item.path}
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        {/* User panel — flex child, sits at bottom naturally, never overlaps nav */}
        {user && (
          <div style={{
            flexShrink: 0,
            padding: '16px 20px',
            borderTop: '1px solid rgba(255,255,255,0.1)',
            background: 'rgba(0,0,0,0.15)',
          }}>
            <div style={{ fontSize: '13px', fontWeight: '600', color: '#ecf0f1', marginBottom: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.name}
            </div>
            <div style={{ fontSize: '11px', color: '#95a5a6', marginBottom: '10px' }}>{user.role}</div>
            <button onClick={logout} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#ecf0f1', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', width: '100%' }}>
              Sign Out
            </button>
          </div>
        )}
      </aside>

      <main className="main-content">{children}</main>
    </div>
  );
};

export default Layout;
